import { useState } from 'react';
import { CommunicationType, IInboundEmailCommunication } from 'shared';

import { LoadingOverlay } from '../../Molecules/LoadingOverlay';
import { useCommunications } from '../../../hooks/useCommunications';

import { EmailInboxTable } from './EmailInboxTable';
import { EmailInboxMessageDrawer } from './EmailInboxMessageDrawer';

export function EmailInboxRoute() {
  const [selectedEmail, setSelectedEmail] = useState<IInboundEmailCommunication | null>(null);
  const { data, isLoading, isFetching } = useCommunications({ inboxType: `email` });
  const communications = data?.communications || [];
  const rows = communications
    .filter(comm => comm.type === CommunicationType.INBOUND_EMAIL && !!comm.inboundEmail)
    .map(comm => comm.inboundEmail)
    .filter((inboundEmail): inboundEmail is NonNullable<typeof inboundEmail> => !!inboundEmail)
    .sort((a, b) => {
      const aTime = a.createdAt ? new Date(a.createdAt).getTime() : 0;
      const bTime = b.createdAt ? new Date(b.createdAt).getTime() : 0;

      return bTime - aTime;
    });

  return (
    <>
      <LoadingOverlay loading={ isLoading || isFetching }>
        <EmailInboxTable
          rows={ rows }
          onRowClick={ setSelectedEmail }
        />
      </LoadingOverlay>
      <EmailInboxMessageDrawer
        email={ selectedEmail }
        open={ !!selectedEmail }
        onClose={ () => setSelectedEmail(null) }
      />
    </>
  );
}
